export default __webpack_public_path__ + "static/media/menu2_hl.a952b8dd.png";